var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.image
    ? _c("picture", [
        _c("source", {
          attrs: {
            type: "image/webp",
            srcset: `${
              _vm.image?.sizes?.placeholder
                ? _vm.image.sizes.placeholder
                : _vm.image?.sizes?.medium
            }.webp`,
            "data-srcset": `${
              _vm.image?.sizes?.largeRetina
                ? _vm.image.sizes.largeRetina
                : _vm.image.url
            }.webp 1440w,
         ${_vm.image.sizes.large}.webp 1024w,
         ${_vm.image.sizes.medium_large}.webp 600w,
         ${_vm.image.sizes.medium}.webp 320w`,
          },
        }),
        _vm._v(" "),
        _c("source", {
          attrs: {
            type: _vm.image.mime_type,
            srcset: `${
              _vm.image.sizes?.placeholder
                ? _vm.image.sizes.placeholder
                : _vm.image.sizes.medium
            }`,
            "data-srcset": `${
              _vm.image?.sizes?.largeRetina
                ? _vm.image.sizes.largeRetina
                : _vm.image.url
            } 1440w,
         ${_vm.image.sizes.large} 1024w,
         ${_vm.image.sizes.medium_large} 600w,
         ${_vm.image.sizes.medium} 320w`,
          },
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "lazyload blur-up",
          class: _vm.classImg,
          attrs: {
            "data-expand": "-50",
            width: "400",
            height: "300",
            loading: "lazy",
            "data-src": _vm.image.url,
            alt: _vm.image.alt || _vm.placeholder,
          },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }